import React from "react";
import {
  ScheduleLocation,
  ScheduleIsPatient,
  ScheduleDate,
  ScheduleTime,
  SchedulePreExistingConditions,
  ScheduleSymptoms,
  ScheduleGender,
  ScheduleRace,
  ScheduleEthnicity,
  ScheduleContactTracing,
  SchedulePatientDetails,
  SchedulePatientAddress,
  SchedulePatientContact,
  SchedulePatientVitals,
  ScheduleConsent,
  ScheduleHasInsurance,
  ScheduleInsuranceCard,
  ScheduleConsentProvider,
  ScheduleServiceSelection,
  ScheduleInfluenzaConsent,
  SchedulePublicPlaces,
  ScheduleInfluenzaScreening,
  ScheduleInsuranceVerification,
  SchedulePregnancy,
  ScheduleLocationByDate,
  ScheduleTimeAppointmentOne,
  ScheduleTimeAppointmentTwo,
  ScheduleCovid19ConfirmedCase,
  ScheduleSymptomsVax,
  ScheduleVaxConsent,
  ScheduleAllergies,
  ScheduleSeriousReaction,
  ScheduleLongTermHealth,
  ScheduleImmuneSystem,
  ScheduleImmuneSystemMedications,
  ScheduleNervousSystem,
  ScheduleBloodTransfusion,
  ScheduleRecentVaccinations,
  ScheduleCovid19TestType,
  ScheduleFlightInfo,
  ScheduleOccupation
} from "../children";

const SCHEDULE_SCREEN_COMPONENTS = [
  {
    key: "patient-details",
    component: <SchedulePatientDetails />
  },
  {
    key: "is-patient",
    component: <ScheduleIsPatient />
  },
  {
    key: "pre-existing-conditions",
    component: <SchedulePreExistingConditions />
  },
  {
    key: "symptoms",
    component: <ScheduleSymptoms />
  },
  {
    key: "gender",
    component: <ScheduleGender />
  },
  {
    key: "race",
    component: <ScheduleRace />
  },
  {
    key: "ethnicity",
    component: <ScheduleEthnicity />
  },
  {
    key: "contact-tracing",
    component: <ScheduleContactTracing />
  },
  {
    key: "patient-address",
    component: <SchedulePatientAddress />
  },
  {
    key: "patient-contact",
    component: <SchedulePatientContact />,
    hidePaperPanel: true
  },
  {
    key: "patient-vitals",
    component: <SchedulePatientVitals />
  },
  {
    key: "consent",
    component: <ScheduleConsent />
  },
  {
    key: "consent-provider",
    component: <ScheduleConsentProvider />
  },
  {
    key: "date",
    component: <ScheduleDate />
  },
  {
    key: "location",
    component: <ScheduleLocation />,
    hidePaperPanel: true
  },
  {
    key: "time",
    component: <ScheduleTime />
  },
  {
    key: "insurance",
    component: <ScheduleHasInsurance />
  },
  {
    key: "insurance-card",
    component: <ScheduleInsuranceCard />
  },
  {
    key: "insurance-verification",
    component: <ScheduleInsuranceVerification />
  },
  {
    key: "service-selection",
    component: <ScheduleServiceSelection />
  },
  {
    key: "influenza-screening",
    component: <ScheduleInfluenzaScreening />
  },
  {
    key: "influenza-consent",
    component: <ScheduleInfluenzaConsent />
  },
  {
    key: "public-places",
    component: <SchedulePublicPlaces />
  },
  {
    key: "pregnancy",
    component: <SchedulePregnancy />
  },
  {
    key: "location-by-date",
    component: <ScheduleLocationByDate />,
    hidePaperPanel: true
  },
  {
    key: "time-appointment-one",
    component: <ScheduleTimeAppointmentOne />,
    hidePaperPanel: true
  },
  {
    key: "time-appointment-two",
    component: <ScheduleTimeAppointmentTwo />,
    hidePaperPanel: true
  },
  {
    key: "covid-19-confirmed-case",
    component: <ScheduleCovid19ConfirmedCase />
  },
  {
    key: "symptoms-vax",
    component: <ScheduleSymptomsVax />
  },
  {
    key: "vax-consent",
    component: <ScheduleVaxConsent />
  },
  {
    key: "covid19vax-allergies",
    component: <ScheduleAllergies />
  },
  {
    key: "covid19vax-serious-reaction",
    component: <ScheduleSeriousReaction />
  },
  {
    key: "covid19vax-long-term-health",
    component: <ScheduleLongTermHealth />
  },
  {
    key: "covid19vax-immune-system",
    component: <ScheduleImmuneSystem />
  },
  {
    key: "covid19vax-immune-system-medications",
    component: <ScheduleImmuneSystemMedications />
  },
  {
    key: "covid19vax-nervous-system",
    component: <ScheduleNervousSystem />
  },
  {
    key: "covid19vax-blood-transfusion",
    component: <ScheduleBloodTransfusion />
  },
  {
    key: "covid19vax-recent-vaccinations",
    component: <ScheduleRecentVaccinations />
  },
  {
    key: "covid19-test-type",
    component: <ScheduleCovid19TestType />,
    hidePaperPanel: true
  },
  {
    key: "flight-info",
    component: <ScheduleFlightInfo />
  },
  {
    key: "occupation",
    component: <ScheduleOccupation />
  }
];

export { SCHEDULE_SCREEN_COMPONENTS };
